import React from 'react';
import { Paragraph, Text, Tooltip, TooltipPopper } from '@zillow/constellation';

import * as S from './styles';
import type { OutputCardProps } from './../types';

const OutputCard: React.FC<React.PropsWithChildren<React.PropsWithChildren<OutputCardProps>>> = ({
  title,
  tooltipText,
  value,
}: OutputCardProps) => {
  const tooltip = <Tooltip body={<Paragraph>{tooltipText}</Paragraph>} />;

  return (
    <S.OutputCardContainer padding="xs">
      <Text fontType="bodySmall" as="h4">
        {title}
        {' '}
        <TooltipPopper triggered={tooltip} />
      </Text>
      <Paragraph fontType="h4" as="strong">
        {value}
      </Paragraph>
    </S.OutputCardContainer>
  );
};

export default OutputCard;
